import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MapService } from 'src/app/Service/map.service';
import { Subject, takeUntil } from 'rxjs';
import axios from 'src/app/Service/axios';

interface Vehicle {
  ChargePriority?: number;
  EstimatedRange?: number;
  LastChargeTime?: number;
  SOH?: number;
}

@Component({
  selector: 'app-cctv-dashboard',
  templateUrl: './cctv-dashboard.component.html',
  styleUrls: ['./cctv-dashboard.component.css']
})
export class CctvDashboardComponent implements OnInit {
  vehicles = [];
  filteredVehicles = [];
  searchKey = new FormControl('');
  private destroy$ = new Subject<void>();

  sortOptions = [
    { label: 'الویت شارژ', value: 'ChargePriority' },
    { label: 'برد تخمینی', value: 'EstimatedRange' },
    { label: 'زمان شارژ', value: 'LastChargeTime' },
    { label: 'سلامت باتری', value: 'SOH' }
  ];
  private sortField: string | null = null;
  public sortDirection: 'asc' | 'desc' = 'asc';

  mdl_Request: FormGroup = this.FormBuilder.group({
    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),
    // strSDate: new FormControl(momentJalaali().subtract(1, 'day').format('jYYYY/jMM/jDD')),
  })

  constructor(
    private _tooltip: NotificationService,
    private FormBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private gurdService: GurdServiceService,
    private _otherService: OtherService,
    private mapService: MapService
  ) { }

  ngOnInit(): void {
    this.getDashboardData();

    this.searchKey.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      this.filterVehicles(value);
    });
  }

  ngOnDestory() {
    this.destroy$.next()
    this.destroy$.complete()
  }

  async getDashboardData() {
    this._otherService.Showspinner();
    let response = JSON.parse((await axios.post(`GetVehicleDashboardData`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());
    this._otherService.nonespinner();

    if (response.ISSessionExpired == true) {
      this._tooltip.showError('نشست کاربری شما منقضی شده است');
      this._otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'vehicle-dashboard' } });
      return;
    }

    if (response.iResult == 0) {
      return this._tooltip.showError(response.strError);
    }

    setTimeout(() => {
      this.vehicles = response;
      this.filteredVehicles = response;
    }, 150);

  }

  formatedPlate(plate: string): string {
    const [first, alphabet, second, pipe, fourth] = plate.split(' ');
    return `${fourth} | ${second} ${alphabet} ${first} `;
  }

  getChargeStatus(priority: number | null | undefined): string {
    switch (priority) {
      case 1:
      case 2:
        return 'Low';
      case 3:
        return '';
        return 'Medium';
      case 4:
        return '';
        return 'Full';
      default:
        return 'Unknown';
    }
  }

  openCarInformation(vehicle) {
    const urlTree = this.router.createUrlTree([
      'carInfo',
      vehicle.strUnitID
    ]);

    const serializedUrl = this.router.serializeUrl(urlTree)
    window.open(serializedUrl, '_blank');
  }

  filterVehicles(searchValue?: string) {
    const search = (searchValue || this.searchKey.value || '').trim();

    if (!search) {
      this.filteredVehicles = [...this.vehicles];
      return;
    }

    this.filteredVehicles = this.vehicles.filter(vehicle => {
      const plate = this.formatedPlate(vehicle.strVehicleNo || '');
      const searchWords = search.split(/\s+/);

      for (const word of searchWords.reverse()) {
        if (!plate.includes(word)) {
          return false;
        }
      }

      return true;
    });
  }

  trackByVehicle(index: number, vehicle: any): string {
    return vehicle.strUnitID || index;
  }

  toggleSort(field: string): void {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }

    this.applySorting();
    this.updateSortUI(field);
  }

  private applySorting(): void {
    if (!this.sortField) {
      this.filteredVehicles = [...this.vehicles];
      return;
    }

    const data = [...this.vehicles];

    data.sort((a, b) => {
      const valA = a[this.sortField as keyof Vehicle];
      const valB = b[this.sortField as keyof Vehicle];

      if (valA == null || valA == '') return 1;
      if (valB == null || valB == '') return -1;

      let comparison = 0;

      if (typeof valA === 'number' && typeof valB === 'number') {
        comparison = valA - valB; // ascending 
      } else {
        comparison = String(valA).localeCompare(String(valB), 'fa-IR');
      }

      return this.sortDirection === 'asc' ? comparison : -comparison;
    });

    this.filteredVehicles = data;
  }

  private updateSortUI(activeField: string): void {
    const labelElement = document.getElementById('sortLabel');

    if (labelElement) {
      if (!this.sortField) {
        labelElement.innerText = 'مرتب‌سازی';
        document.querySelectorAll('.dropdown-menu .badge').forEach((el: HTMLElement) => {
          el.className = 'float-end badge bg-secondary';
          el.innerText = '';
        });
      } else {
        document.querySelectorAll('.dropdown-menu .badge').forEach((el: HTMLElement) => {
          el.className = 'float-end badge bg-secondary';
          el.innerText = '';
        });

        const currentOption = this.sortOptions.find(opt => opt.value === this.sortField);
        labelElement.innerText = currentOption ? currentOption.label : 'مرتب‌سازی';

        const activeBadge = document.getElementById(`badge-${this.sortField}`);
        if (activeBadge) {
          activeBadge.className = 'float-end badge bg-primary';
          activeBadge.innerText = this.sortDirection === 'asc' ? '↑' : '↓';
        }
      }
    }
  }


}
